import React, { Children } from "react";
import classNames from "classnames";
import "@gouvfr/dsfr/dist/component/navigation/navigation.css";
import PropTypes from "prop-types";
import "./Navigation.css";
var Navigation = function (props) {
    var className = props.className, children = props.children, _a = props.id, id = _a === void 0 ? "header-navigation" : _a, _b = props["aria-label"], ariaLabel = _b === void 0 ? "Menu principal" : _b, 
    // @ts-ignore
    __TYPE = props.__TYPE;
    var _classNames = classNames(className, __TYPE, "fr-nav", "dsmj-nav");
    var content = Children.toArray(children).map(function (child, index) { return (React.createElement("li", { key: index, className: "fr-main-nav__list" }, child)); });
    return (React.createElement("nav", { className: _classNames, id: id, role: "navigation", "aria-label": ariaLabel },
        React.createElement("ul", { className: "fr-nav__list" }, content)));
};
Navigation.defaultProps = { __TYPE: "Navigation" };
Navigation.propTypes = { __TYPE: PropTypes.string };
export default Navigation;
